import React from "react";
import { useHistory } from "react-router-dom";

function NotFound() {
  const { push } = useHistory();
  return (
    <div className="notfound flex flex-col mx-auto w-full h-screen bg-dark text-white place-content-center place-items-center ">
      <h1>404 - Not Found!</h1>
      <button onClick={() => push("/")}>Back</button>
    </div>
  );
}

export default NotFound;



// WEBPACK FOOTER //
// ./src/components/NotFound.js